export const SITEGLUE_WORDPRESS_PLUGIN_NAME = "SiteGlue";
export const SITEGLUE_WORDPRESS_PLUGIN_FILE = "wordpress/inbound-gpt-ai-agents/inbound-gpt-ai-agents.php";

export const WORDPRESS_PLUGIN_CURRENT = [
  "MCP server card at /.well-known/mcp.json",
  "llms.txt generated from business settings",
  "HTML link tags for MCP and llms.txt",
  "HTTP Link headers for MCP, llms.txt, and sitemap",
  "robots.txt hints for AI crawlers",
  "JSON-LD Organization markup from business settings",
  "XML sitemap discovery link",
  "Visible For AI agents link",
  "Contact-page location, hours, phone, and email",
  "Admin settings for business name and MCP endpoint",
] as const;

export const WORDPRESS_PLUGIN_PLANNED = [
  "Optional WebMCP when a SiteGlue Agent is connected",
  "WP-CLI install for supported hosts",
  "Trish-guided install through an allowlisted service — never a WordPress password in chat",
] as const;

export const WORDPRESS_WPCLI_COMMAND =
  "wp plugin install https://www.siteglue.ai/resources/wordpress-plugin --activate";

export const WORDPRESS_INSTALL_ALLOWLIST = [
  "publish_llms_txt",
  "publish_mcp_card",
  "publish_html_link_tags",
  "publish_contact_facts",
  "publish_robots_hints",
  "publish_jsonld",
  "rollback_last_change",
] as const;

export type WordpressInstallRequest = {
  siteUrl: string;
  operation: (typeof WORDPRESS_INSTALL_ALLOWLIST)[number];
  authorization: string;
  password?: string;
  appPassword?: string;
};

export function wordpressInstallRejection(input: WordpressInstallRequest): string | null {
  if (input.password || input.appPassword) {
    return "Do not send WordPress administrator passwords. Use the allowlisted install service with a vaulted credential.";
  }
  if (!WORDPRESS_INSTALL_ALLOWLIST.includes(input.operation)) {
    return "That WordPress operation is not allowlisted.";
  }
  if (!input.authorization.trim()) {
    return "Explicit authorization is required before modifying a customer website.";
  }
  return null;
}
